import { createContext } from 'react';

export interface ThemeContextType {
  darkMode: boolean;
}

export const ThemeContext = createContext<ThemeContextType>({
  darkMode: false,
}); 